$(function(){
  //video();
});

function video(){
    
    // Init plyr video player
    const player = new Plyr('#player');

    $('.html-video').click(function() {
        this.play();
        if(this.requestFullscreen){
            this.requestFullscreen();
        } 
        else if (this.webkitRequestFullscreen){
            this.webkitRequestFullscreen();
        }
        else if (this.mozRequestFullScreen){
            this.mozRequestFullScreen();
        }
        else if (this.msRequestFullscreen){
            this.msRequestFullscreen();
        }   
    });
}
